import { format, parseISO } from "date-fns";

import { ISODate, UUID, X500Name, HistoryItem } from "../types/common";

export const emptyFunction = (): void => {
    /* */
};
export const emptyPromise = async (): Promise<undefined> => undefined;

export const getNameInitial = (name: string): string =>
    name[0]?.toUpperCase() ?? "";
export const formatToDate = (dateString: ISODate): string =>
    format(parseISO(dateString), "yyyy/MM/dd");
export const formatToDateWithTime = (dateString: ISODate): string => {
    return format(parseISO(dateString), "MM/dd/yyyy HH:mm O");
};
export const shortenUUID = (uuid: UUID | number): string => String(uuid).slice(0, 8);
export const lastOfArray = <T>(array: T[]): T | undefined =>
    array[array.length - 1];

export const compareDateDesc = (
    a: { lastChangedTime: ISODate },
    b: { lastChangedTime: ISODate },
): number => {
    const aDate = parseISO(a.lastChangedTime);
    const bDate = parseISO(b.lastChangedTime);
    if (aDate > bDate) {
        return -1;
    } else if (bDate > aDate) {
        return 1;
    } else {
        return 0;
    }
};

export const parseX500Name = (x500Name: X500Name): Map<string, string> =>
    new Map(
        x500Name.split(", ").map((item) => {
            const [key, value] = item.split("=");
            return [key, value];
        }),
    );

export const buildUniqueStatusHistory = <
    T extends HistoryItem<unknown>
>(
    items: T[],
): T[] => {
    return [...items]
        .reverse()
        .reduce((acc: T[], cur) => {
            const last = lastOfArray(acc);
            if (last?.status !== cur.status) {
                acc.push(cur);
            }
            return acc;
        }, [])
        .reverse();
};

export const adaptPagination = ({ total = 0, page = 0, size = 10 } = {}) => {
    const pageCount = Math.max(1, Math.ceil(total / size));
    const safePage = Math.min(Math.max(page, 0), pageCount - 1);

    return {
        total,
        page: safePage,
        size,
        pageCount,
        firstPage: safePage <= 0,
        lastPage: safePage >= pageCount - 1,
    };
};